<template>
  <div class="quiz-calculator">
    <div class="calculator__container">
      <div v-if="this.units.length > 1" class="calculator__units">
        <div v-for="(unit, i) in units" :key="unit.name" class="unit" :class="{unit_active: i === activeUnitIndex}" @click="activeUnitIndex = i">
          {{unit.name}}
        </div>
      </div>

      <div class="calculator__content">
        <div class="calculator__input">
          <input v-model="value" type="number" :min="minCorrected" :max="maxCorrected" :maxlength="max.toString().length" :style="{maxWidth: inputLength + 'ch'}" :placeholder="placeholder" @change="validateInput">

          <div class="input__units" v-if="activeUnit.name">{{activeUnit.name}}</div>
        </div>

        <p v-if="!hideCaption" class="input__caption" v-html="$t('quiz.list[1].caption', {mn: minCorrected, mx: maxCorrected, nm: activeUnit.name})"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quiz-calculator",

  props: {
    name: String,
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
    units: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
    },
    hideCaption: {
      type: Boolean,
    }
  },

  computed: {
    activeUnit() {
      return this.units[this.activeUnitIndex];
    },
    inputLength() {
      const maxLength = this.maxCorrected.toString().length;
      const placeholderLength = this.placeholder.length;
      return Math.max(maxLength, placeholderLength);
    },
    minCorrected() {
      return Math.round(this.min * this.activeUnit.multiplier * 100) / 100;
    },
    maxCorrected() {
      return Math.round(this.max * this.activeUnit.multiplier * 100) / 100;
    },
  },

  created() {
    if (this.$i18n.locale === 'ru' && this.units.length > 1) {
      this.activeUnitIndex = 1;
    }
  },

  data() {
    return {
      value: null,
      activeUnitIndex: 0,
    }
  },

  watch: {
    activeUnitIndex(newVal, oldVal) {
      this.validateInput(true, this.units[newVal].multiplier, this.units[oldVal].multiplier);
    },
    placeholder() {
      this.activeUnitIndex = 0;
      this.value = null;
    },
  },

  methods: {
    validateInput(unitsChange, newVal, oldVal) {
      if (unitsChange === true) {
        if (this.value) {
          this.value = Math.round(this.value * (newVal / oldVal));
        } else {
          return;
        }
      }

      if (this.value < this.minCorrected) {
        this.value = this.minCorrected;
      } else if (this.value > this.maxCorrected) {
        this.value = this.maxCorrected;
      }

      this.$emit("changeValue", this.value);

      if (this.activeUnitIndex === 1) {
        localStorage.setItem(this.name, this.value);
      } else {
        localStorage.setItem(this.name, Math.round(this.value * (this.units[1].multiplier / this.units[0].multiplier)));
      }
    },
  },
}
</script>
